import React from 'react';
import './Loading.css';

const Loading = ({ message, overlay = false, variant = 'card', className = '' }) => {
  if (variant === 'spinner' && !overlay) {
    return (
      <div className={`bouncing-loader inline-spinner ${className}`.trim()}>
        <div></div><div></div><div></div>
      </div>
    );
  }

  return (
    <div className={`global-loading-container ${overlay ? 'overlay' : ''} ${className}`.trim()}>
      <div className="global-loading-content variant-card">
        <div className="bouncing-loader">
          <div></div>
          <div></div>
          <div></div>
        </div>
        {message && <div className="global-loading-text">{message}</div>}
      </div>
    </div>
  );
};

export default Loading;
